import { useEffect, useRef } from 'react';
import { resolveIssueTypeConfig } from '../../../constants/issueTypeConfig';

interface Props {
  types: { value: string; label: string; issueTypeDef?: { issueTypeId: string; name: string; icon: string; color: string; customIconPath?: string | null } | null }[];
  onSelect: (type: string) => void;
  onClose: () => void;
}

export default function ChildTypeDropdown({ types, onSelect, onClose }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  return (
    <div
      ref={ref}
      className="absolute right-2 top-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 py-1 min-w-[140px]"
    >
      {types.map((t) => {
        const config = resolveIssueTypeConfig(t.issueTypeDef, t.value);
        const { Icon, color, hexColor } = config;
        return (
          <button
            key={t.value}
            onClick={() => onSelect(t.value)}
            className="flex items-center gap-2 w-full px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <Icon size={14} className={color} style={hexColor ? { color: hexColor } : undefined} />
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
